module.exports = __webpack_public_path__ + "static/media/faq.65cf1e4e.jpg";